import { useContextState } from "../../../../hooks/theme"


export const useStyles = () => {
  const { colors: color } = useContextState()
  return {
    userSelected: ({ haveUser }: { haveUser: boolean }) => ({
      color: haveUser ? color.color1 : color.color13,
      '&.MuiTypography-root': {
        fontSize: '14px'
      }
    }),
    permissionTable: (payload: { loading: boolean }) => ({
      ...!!payload.loading && {
        position: 'relative',
        top: '25%'
      }
    }),
    delete: {
      fontSize: '14px',
      color: 'white',
      marginRight: '10px',
      '&.MuiButtonBase-root':{
        backgroundColor: color.color31,
        '&:hover': { 
          fontSize: '13px',
          transform: 'scale(0.99)', 
        },
      }
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      gap:2
    },
    goBack: {
      display: 'flex',
      justifyContent: 'flex-start',
      '& .MuiSvgIcon-root': {
        fontSize: '1.4rem',
        color: color.color4,
      },
      marginBottom: '20px'
    },
    alignItems: {
      width: '100%',
      alignItems: 'center',
      justifyContent: 'end',
      marginRight: 2,
    },
  }
}
